export const DEFAULT_THEME = 'default-theme';

export const DarkLightSettings = {
  dark: 'dark',
  light: 'light',
  auto: 'auto',
};

export const ThemeColorSettings = {
  red: 'red-theme',
  yellow: 'yellow-theme',
  blue: 'blue-theme',
  green: 'green-theme',
  orange: 'orange-theme',
  purple: 'purple-theme',
  pink: 'pink-theme',
  gray: 'gray-theme',
  brown: 'brown-theme',
  turquoise: 'turquoise-theme',
};

export const ThemeDesignSettings = {
  round: 'round-theme',
  counterBorders: 'counter-borders-theme',
  sharp: 'sharp-theme',
  leaf: 'leaf-theme',
  circle: 'circle-theme'
};
